import React, { useEffect, useState, useRef } from 'react';
import Alert from '@mui/material/Alert';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
const AlertComponent = ({ message, type, close, hideTime }) => {
    const [show, setShow] = useState(false);
    const [hasBeenShown, setHasBeenShown] = useState(false); 
    const timerRef = useRef(null);

    useEffect(() => {
        if (message) {
            setShow(true);
            setHasBeenShown(true); 
            timerRef.current = setTimeout(() => {
                setShow(false);
                close();
            }, hideTime * 1000);
        } else {
            if (hasBeenShown) {
                setHasBeenShown(false);
            }
        }

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, [message, hideTime, close, hasBeenShown]); 

    const handleAlertClose = () => {
        setShow(false);
        clearTimeout(timerRef.current);
        close();
    };

    let icon;
    switch (type) {
        case 'success':
            icon = <CheckCircleIcon fontSize="inherit" />;
            break;
        case 'warning':
            icon = <WarningIcon fontSize="inherit" />;
            break;
        case 'error':
            icon = <ErrorIcon fontSize="inherit" />;
            break;
        default:
            icon = null;
    }

    return (
        <div className='alert-wrapper' style={{ display: show ? 'inherit' : 'none' }}>
            <Alert className={`alert-${type}`} variant="filled" placement="top-start" icon={icon} onClose={handleAlertClose}>
                {message}
            </Alert>
        </div>
    );
};

export default AlertComponent;